export default __webpack_public_path__ + "static/media/hero_image.7d6bde8a.png";